import React from 'react';
import { Hero } from '../components/landing/Hero';
import { OpeningHook } from '../components/landing/OpeningHook';
import { ProblemSection } from '../components/landing/ProblemSection';
import { FailedApproaches } from '../components/landing/FailedApproaches';
import { MechanismReveal } from '../components/landing/MechanismReveal';
import { WhatYouGet } from '../components/landing/WhatYouGet';
import { AudienceSection } from '../components/landing/AudienceSection';
import { HowItWorks } from '../components/landing/HowItWorks';
import { ProofSection } from '../components/landing/ProofSection';
import { FAQSection } from '../components/landing/FAQSection';
import { BonusIntro } from '../components/landing/BonusIntro';
import { BonusStack } from '../components/landing/BonusStack';
import { ValueTable } from '../components/landing/ValueTable';
import { FinalCTA } from '../components/landing/FinalCTA';
import { PostCTAReassurance } from '../components/landing/PostCTAReassurance';
import { Footer } from '../components/landing/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function CortisolSwitchPage() {
  const {
    trackEvent
  } = useMetaPixel();
  return <main className="min-h-screen bg-slate-900 text-slate-50 selection:bg-amber-500/30 selection:text-amber-200" data-id="element-683">
      <Hero data-id="element-684" />
      <OpeningHook data-id="element-685" />
      <ProblemSection data-id="element-686" />
      <FailedApproaches data-id="element-687" />
      <MechanismReveal data-id="element-688" />
      <WhatYouGet data-id="element-689" />
      <AudienceSection data-id="element-690" />
      <HowItWorks data-id="element-691" />
      <ProofSection data-id="element-692" />
      <FAQSection data-id="element-693" />
      <BonusIntro data-id="element-694" />
      <BonusStack data-id="element-695" />
      <ValueTable data-id="element-696" />
      <FinalCTA onAddToCart={() => trackEvent('AddToCart', {
      content_name: 'The Cortisol Switch',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    })} data-id="element-697" />
      <PostCTAReassurance data-id="element-698" />
      <Footer data-id="element-699" />
    </main>;
}